import { Slot } from "@-/com.npmjs.expo-router";

export default function SupportLayoutRoute() {
  return <Slot />;
}
